function types(typesOrRoute) {
    const normalizedTypes = "types" in typesOrRoute ? typesOrRoute.types : typesOrRoute;
    const result = (childTypesOrRoute) => {
        const normalizedChildTypes = "types" in childTypesOrRoute ? childTypesOrRoute.types : childTypesOrRoute;
        return types({
            types: {
                params: Object.assign(Object.assign({}, normalizedTypes.params), normalizedChildTypes.params),
                searchParams: Object.assign(Object.assign({}, normalizedTypes.searchParams), normalizedChildTypes.searchParams),
                state: Object.assign(Object.assign({}, normalizedTypes.state), normalizedChildTypes.state),
                hash: mergeHashValues(normalizedTypes.hash, normalizedChildTypes.hash),
            },
        });
    };
    return Object.assign(result, normalizedTypes);
}
function mergeHashValues(firstHash, secondHash) {
    if (!firstHash && !secondHash) {
        return undefined;
    }
    if ((firstHash === null || firstHash === void 0 ? void 0 : firstHash.length) === 0 || (secondHash === null || secondHash === void 0 ? void 0 : secondHash.length) === 0) {
        return [];
    }
    return [...(firstHash !== null && firstHash !== void 0 ? firstHash : []), ...(secondHash !== null && secondHash !== void 0 ? secondHash : [])];
}
export { types };
